import { ArticleNodeType, SubArticleNodeType } from './contract-object.types';

export class AddArticle {
  static readonly type = '[Contract.Article] Add Article';
  constructor(public lineID: string, public articleType: ArticleNodeType, public article?: any, public profile?: any) {}
}

export class UpdateArticle {
  static readonly type = '[Contract.Article] Update Article';
  constructor(public article: any) {}
}

export class CloneArticle {
  static readonly type = '[Contract.Article] Clone Article';
  constructor(public articleID: number, public copies: number = 1, public copyProducts: boolean = true) {}
}

export class DeleteArticle {
  static readonly type = '[Contract.Article] Delete Article';
  constructor(public articleID: number) {}
}

export class RestoreArticle {
  static readonly type = '[Contract.Article] Restore Article';
  constructor(public articleID: number) {}
}

export class ReplaceLocationOnArticles {
  static readonly type = '[Contract.Article]  Replace Location on Articles';
  constructor(public fromLocNum: string, public toLocNum: string) {}
}

export class RemoveSubLocationFromArticle {
  static readonly type = '[Contract.Article]  Remove SubLocation From Article';
  constructor(public locNum: string, public subLocNum: string) {}
}

export class AddProductsToArticle {
  static readonly type = '[Contract.Article]  Add Products To Article';
  constructor(public articleID: number, public products: any[], public autoDisplay: boolean = false) {}
}

export class RemoveProductsFromArticle {
  static readonly type = '[Contract.Article] Remove Products From Article';
  constructor(public articleID: number, public costIDs: number[]) {}
}

export class SetCurrentArticle {
  static readonly type = '[Contract.Article] Set Current Article';
  constructor(public article: any) {}
}

export class SetPrimaryPerilProduct {
  static readonly type = '[Contract.Article] Set Primary Peril Product';
  constructor(public articleID: number, public productCode: string) {}
}

export class SetArticleChanged {
  static readonly type = '[Contract.Article] Set Article Changed';
  constructor(public articleID: number) {}
}

//SubArticle Actions
export class AddSubArticle {
  static readonly type = '[Contract.Article] Add SubArticle';
  constructor(public articleID: number, public subArticleType: SubArticleNodeType, public subArticle?: any) {}
}

export class UpdateSubArticle {
  static readonly type = '[Contract.Article] Update SubArticle';
  constructor(public articleID: number, public subArticle: any) {}
}

export class CloneSubArticle {
  static readonly type = '[Contract.Article] Clone SubArticle';
  constructor(public articleID: number, public subArticleID: string, public copies: number = 1) {}
}

export class DeleteSubArticle {
  static readonly type = '[Contract.Article] Delete SubArticle';
  constructor(public articleID: number, public subArticleID: string) {}
}

export class RestoreSubArticle {
  static readonly type = '[Contract.Article] Restore SubArticle';
  constructor(public articleID: number, public subArticleID: string) {}
}

export class AddVehicleDriverSubArticle {
  static readonly type = '[Contract.Article] Add Vehicle Driver SubArticle';
  constructor(public vehNum: any, public subArticle?: any) {}
}

export class UpdateVehicleDriverSubArticle {
  static readonly type = '[Contract.Article] Update Vehicle Driver SubArticle';
  constructor(public subArticle: any) {}
}

export class AddArticleInterestPointer {
  static readonly type = '[Contract.Article] Add Article Interest Pointer';
  constructor(public articleID: number, public interestID: string) {}
}

export class RemoveArticleInterestPointer {
  static readonly type = '[Contract.Article] Remove Article Interest Pointer';
  constructor(public articleID: number, public interestID: string) {}
}

export class DeleteSubArticleOnParentDeleted {
  static readonly type = '[Contract.Article] Delete SubArticle On Parent Deleted';
  constructor(public articleID: number, public subArticleID: string) {}
}
